import React from "react";
import styled from "styled-components";
import { CaptionSemibold } from "../Typography";
import ModuleBtnStyle from "./ModuleBtnStyle";

import theme from "../../styles/theme";

const PrimaryBtn = styled.button`
  ${ModuleBtnStyle};
  padding: 17px 24px 16px;
  border-radius: 4px;
  border: ${() => theme.colors.green5} solid 1px;
  color: ${() => theme.colors.green2};

  &:hover {
    border: ${() => theme.colors.green4} solid 1px;
  }
  ${() => theme.media.desktopUp`
    padding: 17px 30px 16px;
  `}
`;

const SecondaryBtn = styled.button`
  ${ModuleBtnStyle};
  padding: 17px 24px 16px;
  border-radius: 4px;
  background-color: transparent;
  color: ${() => theme.colors.green5};
  border: ${() => theme.colors.green5} solid 1px;
  &:hover {
    background-color: transparent;
  }
  ${() => theme.media.desktopUp`
    padding: 17px 30px 16px;
  `}
`;

const ButtonText = styled(CaptionSemibold)`
  color: inherit;
  margin: 0;
  line-height: 100%;
`;

const NavButton = ({ type, children, className, onClick }) => {
  return (
    <>
      {type === "primary" && (
        <PrimaryBtn onClick={onClick} className={className}>
          <ButtonText>{children}</ButtonText>
        </PrimaryBtn>
      )}
      {type === "secondary" && (
        <SecondaryBtn onClick={onClick} className={className}>
          <ButtonText>{children}</ButtonText>
        </SecondaryBtn>
      )}
    </>
  );
};

export default NavButton;
